import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Spinner } from '@carvana/showroom-spinner';
import { useDualEventTracking } from '../../utils/useDualEventTracking';
import DisableAutoPayTile from './turn-off-autopay-tile';
import {
  MyCarsContentWrapper,
  DisableAutoPayWrapper,
  SpinnerWrapper,
} from './TurnOffAutopay.styles';
import BackLink from '../future-packages/back-link';
import MyCarsRefreshHook from '../../utils/MyCarsRefreshHook';
import { getBankInfo } from '../../ducks/selectors';

const TurnOffAutoPay = () => {
  const { id: vehicleId }: any = useParams();
  const { trackEvent } = useDualEventTracking();
  useEffect(() => trackEvent('TurnOffAutoPay Screen'), []);

  // Refresh Hook - Avoid selectors/ redux state access before the refresh hook and loader
  const isLoading = MyCarsRefreshHook(vehicleId);
  const bankInfo = useSelector(getBankInfo)?.[0];

  if (isLoading) {
    return (
      <SpinnerWrapper>
        <Spinner />
      </SpinnerWrapper>
    );
  }

  const confirmationText = `I understand that I am requesting my Auto Pay to be canceled. This can take up to three business days to process. I am still responsible to make payments on time. I agree to Bridgecrest’s `;
  const consentUrlText =
    'Consent to Use Electronic Signatures and Communications';
  const disclaimer =
    'By tapping the “Turn Off Auto Pay” button below, I authorize Bridgecrest to cancel the automated payment program for my account and I understand that it is my responsibility to make my payment through one of the other payment options provided by Bridgecrest.';
  const backArrowText = 'Back To Loan Details';

  return (
    <DisableAutoPayWrapper>
      <MyCarsContentWrapper>
        <BackLink
          backLinkTrackEvent="CLTV-OEM-My-Cars-Loan_Details_Back_Loan_Details_Button"
          backLinkRoute={`/loan-detail/${vehicleId}`}
          backLinkText={backArrowText}
        />
        <DisableAutoPayTile
          vehicleId={vehicleId}
          confirmationLabel={confirmationText}
          disclaimerText={disclaimer}
          consentUrlText={consentUrlText}
          last4AccountNumber={bankInfo?.last4OfPaymentMethod}
        />
      </MyCarsContentWrapper>
    </DisableAutoPayWrapper>
  );
};

export default TurnOffAutoPay;
